module.exports = __webpack_public_path__ + "img/logo-horizontal-dark-wt-goldy.605fae94.png";